/* tslint:disable:member-ordering */
import $ = require('jquery');
let appsCatalog = require<any>('diy/site-admin/apps-catalog/appsCatalog');
import BlankModuleDragSource = require('diy/module/common/js/dd/BlankModuleDragSource');
import BlankModuleHelper = require('diy/module/common/js/dd/BlankModuleHelper');
import l10n from 'diy/util/l10n';
let siteadminApi = require<any>('diy/site-admin/main/api');
import AppRegistry from 'diy/AppRegistry';

declare var cms: any;
declare var Hammer: any;
type HammerEvent = any;

class ModuleSelector {

    private mouseDownOnModule = false;
    private uninstallRequestTimeout = 5000;
    private limitationsCallout = false;
    private limitationsMsg = '';

    private loaded = false;

    init() {
        $(document).on('diy-siteadmin-window-resize-completed', (e) => {
            //do this just for the module Selector window
            if (siteadminApi.getWindow().getContentElement().find('.adminModuleSelector').length) {
                this.resizeModulesContainer();
                this.setInactive();
            }
        });
    };

    reset() {
        this.loaded = false;
    };

    setLimitCallout() {
        let msgClass = '';
        if ($("#cc-sa-sidebar").hasClass('modules-maximum')) {
            this.limitationsCallout = true;
            this.limitationsMsg = l10n('limitations.maxAmountModulesPerPage');
            msgClass = 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip';
            this.disableModuleSelector(true);
        } else if ($("#cc-sa-sidebar").hasClass('modules-critical')) {
            this.limitationsCallout = true;
            msgClass = 'diy-alert-tooltip diy-error-tooltip diy-icon-tooltip limitation-warning';
            this.limitationsMsg = l10n('limitations.warningAmountModulesPerPage');
            this.disableModuleSelector(false);
        } else {
            this.limitationsCallout = false;
            this.disableModuleSelector(false);
        }

        if (this.limitationsCallout) {
            this.showCallout(this.limitationsMsg, msgClass);
            $(".adminModuleSelector .sections-callout").empty();
        } else {
            $(".adminModuleSelector .limitations-callout").empty();
            this.showSectionTeaser(l10n('limitations.crossLinkToSections'), 'diy-info-tooltip diy-sections-icon');
        }

        this.resizeModulesContainer();
    };

    private getModulesContainer() {
        return $('div.cc-sa-controller-moduleSelector main #adminAddlist');
    };

    private showSectionTeaser(message: string, className: string) {
        $(".adminModuleSelector .sections-callout").diy_simpleTooltip({
            positionMode: 'static',
            content: message,
            triggerMode: 'none',
            appendTo: ".adminModuleSelector .sections-callout",
            'cls': className
        });

        $(".adminModuleSelector .sections-callout").diy_simpleTooltip('show');
    }
    /**
     * Show warning callout at the top of the modules list
     */
    private showCallout(limitationsMsg: string, msgClass: string) {
        $(".adminModuleSelector .limitations-callout").diy_simpleTooltip({
            positionMode: 'static',
            content: limitationsMsg,
            triggerMode: 'none',
            appendTo: ".adminModuleSelector .limitations-callout",
            'cls': msgClass,
            'contentIcon': 'ui-icon-alert'
        });

        $(".adminModuleSelector .limitations-callout").diy_simpleTooltip('show');
    };

    private disableModuleSelector(disable: boolean) {
        if (disable) {
            $('div.cc-sa-controller-moduleSelector main .adminModuleSelector').loadingBox({
                useOverlay: true,
                hideLoader: true
            }).show();

            if ($('.loadingBox-overlay').length > 0) {
                $(".adminModuleSelector .limitations-callout")
                    .css('z-index', $('.loadingBox-overlay').css('z-index') + 1);
                $(".adminModuleSelector .limitations-callout").css('position', "relative");
            }

        } else {
            $('div.cc-sa-controller-moduleSelector main .adminModuleSelector').loadingBox().remove();
        }
    };

    private resizeModulesContainer() {
        if (this.getModulesContainer().length) {
            let totalH = $('div.cc-sa-controller-moduleSelector').find('main').height();
            let topH = 0;
            $('.adminModuleSelector .inline-tooltip.infoBox').each(function() { topH += $(this).outerHeight(); });
            if ((totalH - topH) !== 0) { //fix for DHDIYE-232
                this.getModulesContainer().height(totalH - topH);
            }
        }
    }
        private toggleActive(el: JQuery) {
            if (!el.hasClass('active') && !el.hasClass('disabled')) {
                this.setInactive(null, true);
                el.addClass('active');

                $(window).bind('scroll.moduleSelector resize.moduleSelector', () => {
                    this.setInactive();
                    $(window).unbind('.moduleSelector');
                });

                let $adminAddList = this.getModulesContainer();

                let extraOptions = el.data('tt_extraOptions');

                el.data('tt_extraOptions', null);

                let baseOptions = {
                    cls: 'module_selector_tooltip',
                    content: !diy.editor.uiPreference.isPointerModeTouch() ?
                        l10n('moduleSelector.moduleTooltip') :
                        l10n('moduleSelector.moduleTooltipMobile')
                };
                $.extend(baseOptions, extraOptions);
                $adminAddList.diy_tooltip('option', baseOptions);

                $adminAddList.diy_tooltip('show', el);
            }
        }
        private setInactive(el?: JQuery, noAnim?: boolean) {
            if (!el) {
                el = $('div.module-selector-item.active');
            }
            el.removeClass('active');

            this.getModulesContainer().diy_tooltip('hide');
        }

    load(url: string, container: JQuery) {
        $.get(url, function (data) {
            //add data
            container.html(data);
        });
    }

    private createDraggables(items: JQuery) {
        let dragHelper = new BlankModuleHelper();
        items.each(function(index, elem) {
            // Breaks cyclic dependencies
            // TODO: move module selector instance to Registry so we don't have cyclic deps anymore
            let DragSourceClass = require<typeof BlankModuleDragSource>(
                'diy/module/common/js/dd/BlankModuleDragSource'
            );
            let dragSource = new DragSourceClass($(elem));
            dragSource.setHelper(dragHelper);
            AppRegistry.getModuleDragDrop().addDragSource(dragSource);
        })
        .on('ddstart ddstop', () => {
            this.setInactive();
        })
        .on('ddstart', function() {
            // hide the site admin window
            // do a siteadmin close call without destroying the controller
            // the controller and module selector html are required during the drag drop process
            siteadminApi.close(false, true);
        })
        .on('ddcancel', function() {
            // Show the module selector again because we cancelled the drop
            $('#cc-sa-item-elements').click();
        });

        this.trialItems(items);
    };

    clearSelection() {
        this.setInactive();
    }

    private trialItems(items: JQuery) {
        items.each(function(index, item) {
            let $item = $(item);
            if ($item.attr('data-oao-trial') === 'true') {
                $item.addClass('isTrial');
            }
            if ($item.attr('data-oao-inactive') === 'true') {
                $item.draggable('disable');
                $item.addClass('isTrial');
            }
        });
    };

    /**
     * Init the Module Selector: sizes, styles, behaviors, event handlers, etc.
     */
    afterFillContent(el: JQuery, data: {}, container: JQuery) {
            //make the draggables
            let items = this.getModulesContainer().find('div.module-selector-item');
            let lastActiveCategory = $.cookie('diy.editor.moduleSelectorCategory');
            let lastActiveCategoryHeading: JQuery;
            let firstCategory = this.getModulesContainer()
                .find('.diye-collapsible-category-header').attr('data-categoryid');

            this.createDraggables(items);

            function showUpgrade(event: JQueryEventObject) {
                event.data.el.trigger('mouseup');
                event.data.el.trigger('click');
            }

            if (!diy.editor.uiPreference.isPointerModeTouch()) {
                let self = this;
                $('.module-selector-item').mousedown(function () {
                    if ($(this).hasClass('active')) {
                        self.mouseDownOnModule = true;
                    }
                    if (diy.editor.upgradeLayer.isElementUpgradable(this)) {
                        $(document).bind('mousemove', {el: $(this)}, showUpgrade);
                    }
                });
                $('.module-selector-item').not('.isTrial').mouseup(function (event) {
                    self.mouseDownOnModule = false;
                    let $this = $(this);
                    $this.addClass('hover');
                    let $originalTarget = $((<any>event).originalTarget || event.srcElement);

                    $this.find('a.full_title').addClass('focus');
                    if (!diy.editor.upgradeLayer.isElementUpgradable($this)
                            // don't show the tooltip for catalog links
                        && ($originalTarget.length === 0 || !$originalTarget.hasClass('js-apps-open-catalog'))
                    ) {
                        self.toggleActive($this);
                    } else {
                        //remove mouse down
                        $(document).unbind('mousemove', showUpgrade);
                    }
                });
            } else {
                let self = this;
                $('.module-selector-item').each(function() {
                    Hammer(this).on('tap', function(this: HTMLElement, e: HammerEvent) {
                        let event = e.gesture.srcEvent;
                        if (diy.editor.upgradeLayer.isElementUpgradable(this)) {
                            showUpgrade(event);
                        } else {
                            let $originalTarget = $(event.originalTarget || event.srcElement);
                            if ($originalTarget.length === 0 || !$originalTarget.hasClass('js-apps-open-catalog')) {
                                self.toggleActive($(this));
                            }
                        }
                    });
                });
            }
            this.getModulesContainer().diy_tooltip({
                anchorOffset: -13,
                delegate: 'div.module-selector-item',
                triggerMode: 'none',
                zIndex: 100110,
                fadeOutDelay: 400,
                fadeInDelay: 400
            });
            let self = this;
            $('a.short_title, a.full_title').blur(function () {
                //this is for ie8, dont let setting inactive if
                //is mouse down on the element
                if (self.mouseDownOnModule !== true) {
                    //do not set inactive, it another link is active, this is for ie9
                    let activeLink = $('.module-selector-item a.focus');
                    if (activeLink.length === 0) {
                        self.setInactive();
                    }
                }
            });
            self.getModulesContainer().scroll(function () {
                self.setInactive();
            });
            $(window).resize(function () {
                self.resizeModulesContainer();
            });

            //resize the modules container
            self.resizeModulesContainer();

            // init squeeze box (scroll handle + always in view) //
            self.getModulesContainer().diy_scrollHandle();
            self.getModulesContainer().diy_alwaysInViewBehavior({
                clickToOpen: true,
                fixableSelector: '.diye-collapsible-category-header',
                fixedClassName: 'fixed',
                activeClassName: 'active'
            });

            // listed to opened sections //
            self.getModulesContainer()
                .find('.diye-collapsible-category-header')
                .bind('alwaysInViewBehavior-activated', function (event) {
                    let categoryId = $(event.target).attr('data-categoryid');

                    // remember the last active category //
                    $.cookie('diy.editor.moduleSelectorCategory', categoryId, {path: '/'});

                    $(document).trigger( 'diy-editor-generic-sectionAccessed', {
                        sectionCodeName: 'elements.' + categoryId
                    });
                });

            // auto-open last know category //
            lastActiveCategoryHeading = $(
                '.diye-collapsible-category-header[data-categoryId="' +
                lastActiveCategory + '"]'
            );
            if (lastActiveCategory && lastActiveCategory !== firstCategory && lastActiveCategoryHeading.length) {
                self.getModulesContainer().diy_alwaysInViewBehavior(
                    'scrollToItem',
                    lastActiveCategoryHeading.get(0),
                    function() {
                        $(document).trigger('moduleSelectorInitialized');
                    },
                    0 // scroll instantly
                );
            // if no category is auto-opened then the first one is by default open //
            } else {
                $(document).trigger( 'diy-editor-generic-sectionAccessed', {
                    sectionCodeName: 'elements.' + firstCategory
                });
                $(document).trigger('moduleSelectorInitialized');
            }

            // catalog events
            self.attachCatalogEvents();

            //check the limitations and set the callout
            self.setLimitCallout();

            // initialize help link
            cms.help.GuidedAssistant._instance._initSiteAdminButtonByClass(
                cms.help.GuidedAssistant.options.modulesLinkClass);

            $(document.body).trigger('ModuleSelectorOpened.BSA');
        self.loaded = true;

    };

    /**
     * Create apps related behaviors
     */
    attachCatalogEvents() {

        // open catalog buttons
        this.getModulesContainer().find('.js-apps-open-catalog').each(function (index, element) {
            let $element = $(element);
            if ($element.hasClass('apps-catalog-button')) {
                $element.button({
                    icons: {
                        primary: "ui-icon-1and1-external"
                    }
                });
            }
            $element.bind('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                $('#cc-sa-item-appscatalog').data('customHref', $(this).attr('href'));
                $('#cc-sa-item-appscatalog').click();
            });
        });

        let self = this;

        // delete buttons
        $('.has-catalog-data .delete-button').click(function (event) {
            event.preventDefault();
            let $this = $(this);
            //ask the user for a confirmation
            let dialog = $(
                '<div>'
                + l10n('moduleSelector.windowMain.delete.confirmation.message')
                + '</div>'
            ).diy_confirmationDialog({
                position: {
                    my: 'center',
                    at: 'center',
                    of: self.getModulesContainer()
                },
                dialogClass: "confirmation-dialog deleteWebComponentDialog",
                buttons: [
                     {
                         text: l10n('moduleSelector.windowMain.delete.confirmation.accept'),
                         click: function () {
                             let moduleSelectorItem =
                                 $this.parents('.module-selector-item');
                             let wcId = moduleSelectorItem.attr('data-webcomponentid');
                             //set the error to be triggered unless success or error
                             //callbacks cancel this
                             let to = setTimeout(function () {
                                 self.showErrorMessageOnItem($this, 'timeout');
                             }, self.uninstallRequestTimeout);
                             appsCatalog.uninstallWebComponent(wcId, {
                                 success: function (data: any) {
                                     clearTimeout(to);
                                     //remove the element
                                     moduleSelectorItem.remove();
                                     siteadminApi.destroyController('cc-sa-item-appscatalog');
                                     // update the scrolling element
                                     self.getModulesContainer().trigger('contentchanged');
                                 },
                                 error: function () {
                                     clearTimeout(to);
                                     self.showErrorMessageOnItem(
                                         moduleSelectorItem,
                                         l10n('moduleSelector.windowMain.delete.error.message')
                                     );
                                 }
                             });
                             dialog.diy_confirmationDialog('destroy');
                         }
                     },
                     {
                         text: l10n('moduleSelector.windowMain.delete.confirmation.cancel'),
                         click: function () {
                             dialog.diy_confirmationDialog('destroy');
                         },
                         "class": "button-cancel"
                     }
                ],
                create: function () {
                    self.setInactive();
                },
                modal: true,
                zIndex: 100201
            });
        });
    };

    show() {
        if (this.loaded === true) {
            this.resizeModulesContainer();
            let lastActiveCategoryHeading = this.getModulesContainer()
                .find('div.diye-collapsible-category-header.active');
            if (lastActiveCategoryHeading.length) {
                this.getModulesContainer().diy_alwaysInViewBehavior(
                    'scrollToItem',
                    lastActiveCategoryHeading.get(0),
                    function() {
                        $(document).trigger('moduleSelectorInitialized');
                    },
                    0 // scroll instantly
                );
            } else {
                $(document).trigger('moduleSelectorInitialized');
            }
        }
    }

    showErrorMessageOnItem(item: JQuery, message: string) {
        let wcId = item.attr('data-webcomponentid');
        let catId = item.attr('data-categoryid');
        setTimeout(() => {
            item.data('tt_extraOptions', {
                cls: 'diy-alert-tooltip module_selector_tooltip',
                content: message
            });
            this.focusItem('webcomponent', wcId, catId);
        }, 40);
    };

    /**
     * Opens a category
     */
    openCategory(categoryIdentifier?: string) {
        if (!categoryIdentifier) {
            return false;
        }

        this.getModulesContainer().diy_alwaysInViewBehavior(
            'scrollToItem',
            $('.diye-collapsible-category-header[data-categoryId="' + categoryIdentifier + '"]').get(0)
        );

        return false;
    };

    /**
     * Scrolls to a webcomponent or module and shows its callout.
     */
    focusItem(type: 'webcomponent'|'module', id: string, cat: string) {
        let element: JQuery;
        let callback: () => void;
        if (type === 'webcomponent') {
            element = this.getModulesContainer().find('[data-webcomponentid="' + id + '"]');
        } else if (type === 'module') {
            element = this.getModulesContainer().find('[data-modulename="' + id + '"]');
        }

        // filter by category
        if (cat) {
            element = element.filter('[data-categoryid="' + cat + '"]');
        }

        // if no element matched then stop //
        if (!element.length) {
            return;
        }

        // limit to the first found element //
        element = element.first();

        callback = function(){
            setTimeout(function(){
                element.mousedown().mouseup();
            }, 30);
        };

        this.getModulesContainer().diy_alwaysInViewBehavior(
            'scrollToItem',
            element.get(0),
            callback
        );
    };

    /**
     * Opens the Module Selector and then...
     * Scrolls to a webcomponent or module and shows its callout.
     */
    jumpToItem(type: 'webcomponent'|'module', id: string, cat: string) {
        if ($('#cc-sa-item-elements').hasClass('cc-sa-active')) {
            this.focusItem(type, id, cat);
        } else {
            $(document).one('moduleSelectorInitialized', () => {
                this.focusItem(type, id, cat);
            });
            $('#cc-sa-item-elements').click();
        }

    };

    /**
     * Jumps to a web component
     */
    jumpToWebComponent(wcId: string, cat: string) {
        this.jumpToItem('webcomponent', wcId, cat);
    };

    /**
     * Jumps to a module
     */
    jumpToModule(modId: string, cat: string) {
        this.jumpToItem('module', modId, cat);
    };
}

let moduleSelector = new ModuleSelector();
export default moduleSelector;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/module-selector/moduleSelector.ts
 **/